import { render, staticRenderFns } from "./TradeRequestReport.vue?vue&type=template&id=d0e788d0"
import script from "./TradeRequestReport.vue?vue&type=script&lang=js"
export * from "./TradeRequestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports